import request from '@/utils/ajax';

export function syncFriend(botId){
  return request({
    url: `/wx/manage/wxBotClientFriend/sync/${botId}`,
    method: 'put',
  });
}

export function syncGroupChat(botId){
  return request({
    url: `/wx/manage/wxBotClientGroup/sync/${botId}`,
    method: 'put',
  });
}

export function synctags(botId){
  return request({
    url: `/wx/manage/wxBotClientTag/sync/${botId}`,
    method: 'put',
  });
}


export function queryBotList(data){
  return request({
    url: `/wx/manage/wxBotClientInfo/list`,
    method: 'get',
    params: data,
  });
}

export function loginOutWechat(id){
  return request({
    url: `/wx/manage/wxBotClientInfo/logout/${id}`,
    method: 'put',
  });
}
